import Immutable from "immutable";

import createStore from "./createStore";

export const reducer = createStore({
    SET_EVENT_DIVISION: (state, action) =>
        state.set(action.event_division_id, Immutable.fromJS(action.data)),
});
